import { render } from "./InteractionMessages.vue?vue&type=template&id=6f7f6a3f&scoped=true"
import script from "./InteractionMessages.vue?vue&type=script&lang=js"
export * from "./InteractionMessages.vue?vue&type=script&lang=js"

import "./InteractionMessages.vue?vue&type=style&index=0&id=6f7f6a3f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f7f6a3f"]])

export default __exports__